
































































































































































































































































import { Component, Prop, Mixins } from "vue-property-decorator";
import _ from "@/boot/lodash";
import { SnackbarProgrammatic as $snackbar } from "buefy";

// Mixins
import Context from "@/mixins/context";

// Enums/Data
import { InvoiceStatusMap } from "@/data/enums/invoice";
import { DataModules } from "@/store/modules/data";

// Types
import { IInvoice } from "@/models/invoices";
import { Location as VueLocation } from "vue-router";
import { mapGetters } from "vuex";

@Component({
  components: {
    "relative-invoice-status": () =>
      import("@/components/app/global/invoices/relativeInvoiceStatus.vue"),
    "order-items-summary": () =>
      import("@/components/app/global/orders/orderItemsSummary.vue")
  },
  computed: {
    ...mapGetters({
      isMultibrand: "brand/isMultibrand"
    })
  }
})
export default class InvoiceRowItem extends Mixins(Context) {
  // Props

  @Prop({ default: null })
  public invoice!: IInvoice;

  @Prop({ default: null })
  public invoiceId!: IInvoice["id"];

  @Prop({ default: null })
  public clientId!: IInvoice["client_id"];

  @Prop({ default: false })
  public isLoading!: boolean;

  @Prop({ default: false })
  public isSelectable!: boolean;

  @Prop({ default: () => [] })
  public selectedIds!: IInvoice["id"][];

  @Prop({ default: false })
  public readonly isSelectedLinked!: boolean;

  // Data

  public isMultibrand!: boolean;

  // Computed

  public get mappedStatus() {
    if (!this.invoice) return null;
    return InvoiceStatusMap(this.invoice, this.$t("_.invoice"));
  }

  public get showClient() {
    return !this.clientId && this.isAdmin;
  }

  public get invoiceCategoryName() {
    if (!this.invoice) return "";
    return this.$store.getters[
      `data/${DataModules.INVOICES}/getInvoiceCategoryName`
    ](this.invoice);
  }

  public get showSkeletons() {
    return _.isNull(this.invoice);
  }

  public get isSelected() {
    if (!this.isSelectable) return false;
    return _.some(this.selectedIds, id => id === this.invoice?.id);
  }

  public get invoiceRoute(): VueLocation | null {
    if (!this.invoice) return null;
    return this.$store.getters[`data/${DataModules.INVOICES}/getRoute`](
      this.invoice.id,
      this.invoice.client_id
    );
  }

  public get isPayable() {
    if (!this.invoice) return false;

    return this.$store.getters[`data/${DataModules.INVOICES}/isPayable`](
      this.invoice
    );
  }

  // Methods

  public handleSelect(value) {
    this.$emit("selectInvoice", this.invoice, value);
  }

  public async openPayInvoiceModal() {
    const modal = await this.$store.dispatch("ui/open/windowModal", {
      config: {
        component: () =>
          import("@/components/app/global/payments/invoicePaymentModal.vue"),
        props: {
          invoice: this.invoice
        },
        width: 740,
        events: {
          success: async () => {
            modal.close();
            // Redirect to invoice
            await this.$router
              .push(
                this.$store.getters[`data/${DataModules.INVOICES}/getRoute`](
                  this.invoice.id,
                  this.invoice.client_id
                )
              )
              .catch(err => err);
            window.location.reload();
          },
          fail: () => {
            $snackbar.open({
              message: this.$t("_.payment_failed") as string,
              type: "is-warning"
            });
          }
        }
      }
    });
  }
}
